// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  Typography,
} from '@iheartjane/reefer';

type CarouselBannerProps = {
  activeIndex: number;
  totalItems: number;
  updateIndex: (index: number) => void;
};

const CarouselPagination = styled.div(() => ({
  width: '100%',
}));

const RightButtonWrapper = styled.div(() => ({
  flex: 'none',
  top: 'calc(50% - 24px)',
  right: '10px',
  '@media (min-width: 768px)': {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: 'rgb(0 0 0 / 50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'absolute' as const,
    padding: '12px',
  },
}));

const LeftButtonWrapper = styled.div(() => ({
  flex: 'none',
  top: 'calc(50% - 24px)',
  left: '10px',
  '@media (min-width: 768px)': {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: 'rgb(0 0 0 / 50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'absolute' as const,
    padding: '12px',
  },
}));

const PaginationTextWrapper = styled.div(() => ({
  position: 'absolute' as const,
  background: 'rgb(0 0 0 / 50%)',
  borderRadius: '16px',
  padding: '3px 8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  top: '16px',
  right: '16px',
  bottom: 'auto',
}));

export function CarouselBannerPagination({
  activeIndex,
  totalItems,
  updateIndex,
}: CarouselBannerProps) {
  const nextIndex = (activeIndex + 1) % totalItems;
  const prevIndex = (activeIndex + totalItems - 1) % totalItems;

  return (
    <CarouselPagination>
      <LeftButtonWrapper onClick={() => updateIndex(prevIndex)}>
        <ChevronLeftIcon altText="View previous item" color="grays-white" />
      </LeftButtonWrapper>

      <RightButtonWrapper onClick={() => updateIndex(nextIndex)}>
        <ChevronRightIcon altText="View next item" color="grays-white" />
      </RightButtonWrapper>

      <PaginationTextWrapper>
        <Typography variant="mini" color="grays-white">
          {activeIndex + 1}&#47;{totalItems}
        </Typography>
      </PaginationTextWrapper>
    </CarouselPagination>
  );
}
